/*
 * types.js 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */

// navigation
export const IMPRINT_DIALOG_VISIBLE = 'IMPRINT_DIALOG_VISIBLE';

// authentication
export const LOGIN_SUCCEEDED = 'LOGIN_SUCCEEDED';
export const LOGOUT = 'LOGOUT';

// teilnehmerliste
export const UPDATE_PARTICIPANT_LIST = 'UPDATE_PARTICIPANT_LIST';

// sortieroptionen
export const ACTIVE_PARTICIPANT_SORT = 'ACTIVE_PARTICIPANT_SORT';
export const SORT_BY_NAME = 'SORT_BY_NAME';
export const SORT_BY_DEADLINE = 'SORT_BY_DEADLINE';
export const SORT_BY_GOAL = 'SORT_BY_GOAL';
export const SORT_BY_STEP = 'SORT_BY_STEP';

// filteroptionen
export const ACTIVE_FILTER = 'ACTIVE_FILTER';
export const FILTER_COMPLETED = 'FILTER_COMPLETED';
export const FILTER_NONE = 'FILTER_NONE';
export const FILTER_NO_ACTION_NEEDED = 'FILTER_NO_ACTION_NEEDED';

// auswahloptionen
export const SELECT_PARTICIPANT = 'SELECT_PARTICIPANT';

// actions für SurveyDialog dialog
export const SAVE_SHOW_SURVEY_DIALOG = 'SAVE_SHOW_SURVEY_DIALOG';
export const CLOSE_SURVEY_DIALOG = 'CLOSE_SURVEY_DIALOG';



// WEBPACK FOOTER //
// ./src/de/ergovia/actions/types.js